import { DropdownPrimeReact } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query"
import {
  getContactosByFilterSimple,
  postContactoInsert,
} from "api/Contacto.service"
import { ContactoReadingSimpleDto } from "api/DTOs/ContactoReadingSimpleDto"
import { ContactoReadingSimpleDtoIPagedEnumerableProps } from "api/Schemas/ContactoReadingSimpleDtoIPagedEnumerable"
import Modal from "common/components/Modal/Modal"
import { TFunction } from "i18next"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { adapterNewContact } from "../../constant"
import FormCrearContactoForm from "../ModalSelectContactDocument/FormNewContact/FormNewContact"

interface DatosContactoProps {
  cif: string
  codigoPais: string
  cp: string
  cpId: number
  direccion: string
  email: string
  poblacion: string | null
  poblacionExtranjera?: string | null
  poblacionId: number
  provincia: string
  provinciaId: number
  razonSocial: string
  telefono: string
}

interface FormikDocumentsProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  values: $TSMigrationFixMe
  setFieldValue: (
    field: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: $TSMigrationFixMe,
    shouldValidate?: boolean
  ) => Promise<void>
  onchange: ({ value }: { value: string }) => void
}

const DropdownContactos = ({
  values,
  setFieldValue,
  onchange,
}: FormikDocumentsProps) => {
  const { t }: { t: TFunction } = useTranslation()

  const [contactos, setContactos] = useState<ContactoReadingSimpleDto[]>([])

  const [keyWord, setKeyWord] = useState("")
  const { data, fetchNextPage, isFetchingNextPage, refetch } = useInfiniteQuery(
    {
      // eslint-disable-next-line @tanstack/query/exhaustive-deps
      queryKey: ["getContactosByFilterSimple"],
      queryFn: ({ pageParam }) => {
        return getContactosByFilterSimple({
          queryParams: {
            Keyword: keyWord,
            SkipCount: pageParam,
          },
        })
      },
      getNextPageParam: (
        lastPage: ContactoReadingSimpleDtoIPagedEnumerableProps
      ) => {
        return lastPage?.currentPage &&
          lastPage.currentPage * 10 < lastPage?.totalCount
          ? lastPage.currentPage * 10
          : undefined
      },
      initialPageParam: 0,
      placeholderData: keepPreviousData,
      refetchOnWindowFocus: false,
      retry: false,
    }
  )

  useEffect(() => {
    const nuevosContactos = data?.pages?.flatMap((page) => page?.items) ?? []

    const contactosFiltrados = nuevosContactos.filter(
      (contacto) => contacto !== null && contacto !== undefined
    )

    setContactos(contactosFiltrados as ContactoReadingSimpleDto[])
  }, [data])

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const loadMoreData = (event: $TSMigrationFixMe) => {
    if (!isFetchingNextPage && event.last === contactos.length) {
      if (
        data &&
        data.pages &&
        data.pages.length > 0 &&
        contactos.length <= data.pages[0].totalCount
      ) {
        fetchNextPage()
      }
    }
  }

  const onContactoFilter = ({ filter }: { filter: string }) => {
    setKeyWord(filter)
    refetch()
  }

  const updateNewContact = async (contacto: DatosContactoProps) => {
    const resp = await postContactoInsert(adapterNewContact(contacto))

    setKeyWord(contacto.razonSocial)
    refetch()
    onchange({ value: resp.data.id })
    setKeyWord("")
    refetch()
    resp.status === 200 &&
      setFieldValue("modals.showCreateContactoModal", false)
  }

  return (
    <>
      <DropdownPrimeReact
        panelClassName='!tw-z-50 !tw-max-w-150'
        value={
          values?.documentoType?.mode === "venta"
            ? values?.librado?.id
            : values?.librador?.id
        }
        placeholder={`${t("crear.documento.selectContact")}`}
        onChange={onchange}
        style={{ maxWidth: "100%" }}
        options={contactos}
        optionLabel='razonSocial'
        optionValue='id'
        className='!tw-rounded !tw-max-w-full !tw-w-full tw-border-1 !tw-h-10 tw-items-center tw-align-middle !tw-p-0 tw-mb-2'
        filter
        emptyMessage={`${t("cuentasContables.notElementAccounts")}`}
        scrollHeight='350px'
        filterMatchMode='contains'
        onFilter={onContactoFilter}
        virtualScrollerOptions={{
          lazy: true,
          onLazyLoad: loadMoreData,
          itemSize: 38,
          showLoader: false,
        }}
      />
      <div
        className='tw-w-full tw-flex tw-flex-row tw-h-6 tw-items-center tw-cursor-pointer tw-text-text-hyperlink'
        onClick={() => setFieldValue("modals.showCreateContactoModal", true)}
      >
        <FontAwesomeIcon
          icon={["fal", "plus"]}
          className='tw-w-4 tw-h-4 tw-mr-2.5'
        />
        <span>
          {t("crear.documento.addContact")}{" "}
          {values?.documentoType?.mode === "venta"
            ? `${t("crear.documento.cliente").toLowerCase()}`
            : `${t("crear.documento.proveedor").toLowerCase()}`}
        </span>
      </div>
      <Modal
        header={t("contactos.crear.newContact")}
        draggable
        visible={values?.modals?.showCreateContactoModal}
        closable={false}
        size='extra-big'
        className='contacto-modals '
      >
        <FormCrearContactoForm
          t={t}
          updateData={updateNewContact}
          onHide={() => setFieldValue("modals.showCreateContactoModal", false)}
        />
      </Modal>
    </>
  )
}

export default DropdownContactos
